import FetchBase from '../Api/FetchBase'
import {
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
  API_ENDPOINTS,
  TOP_RECORDS_LIMIT,
  ERROR_CODE,
} from '../Utils/constants'
import { observable, action, computed } from 'mobx'
import {
  getUtcUnixDate,
  getCurrentTimeMoment,
  getStartDate,
} from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'

export default class CustomersStore extends FetchBase {
  @observable customers = []
  @observable totalCustomers = 0
  @observable customersLoader = false

  @observable companySearchText = ''
  @observable customersPageNo = DEFAULT_PAGE_START
  @observable customersPageLimit = DEFAULT_PER_PAGE_RECORD

  @observable addCustomerData = observable({
    customer: observable({}),
    users: observable([]),
  })
  @observable deleteCustomerLoader = false
  @observable addCustomerModalLoader = false

  @observable editCustomerData = observable({
    customer: observable({}),
    users: observable([]),
  })

  @observable allPosibileStatus = []

  @observable customersUsers = []
  @observable totalCustomersUsers = 0
  @observable customersUsersLoader = false

  @observable orderingUser = undefined
  @observable orderingUserBy = undefined

  @observable emailId = ''
  @observable customerName = ''
  @observable CustomerUserSearchText = ''
  @observable customersUsersPageNo = DEFAULT_PAGE_START
  @observable customersUsersPageLimit = DEFAULT_PER_PAGE_RECORD

  // specific customer data
  @observable scDetails = {}
  @observable scDetailsLoader = false

  @observable scAttachmentsLoader = false
  @observable scAttachmentsUploadLoader = false
  @observable scAttachmentsTotal = 0
  @observable scAttachments = []
  @observable scAttachmentsPageNo = DEFAULT_PAGE_START
  @observable scAttahmentsPageLimit = DEFAULT_PER_PAGE_RECORD
  @observable scAttachmentsSearchText = ''

  @observable cfSelectedDateChoice = undefined
  @observable cfAllFilters = {}

  @observable ordering = undefined
  @observable orderingBy = undefined
  // @observable sortingStatusOrder = undefined
  @observable allRoles = []

  @observable getCustomerByIdLoader = false

  @observable allCustomers = []
  @observable allOwnerCustomerUsers = []
  @observable customerOwners = []
  @observable mediaCentricOwners = []

  @observable customerAttachmentsFilters = {}

  @observable customerDashboardAttachments = []
  @observable customerDashboardActionItems = []
  @observable customerDashboardAttachmentsPageNo = DEFAULT_PAGE_START
  @observable customerDashboardActionItemsPageNo = DEFAULT_PAGE_START
  @observable customerDashboardAttachmentsTotal = 0
  @observable customerDashboardActionItemsTotal = 0

  @observable customerActionItems = []
  @observable customerActionItemsTotal = 0
  @observable customerActionItemsLoader = false
  @observable customerActionItemsPageNo = DEFAULT_PAGE_START
  @observable customerActionItemsSearchText = ''

  @observable customerGraphStats = []
  @observable customerGraphStatsLoader = false
  @observable customerGraphProjectsTotal = 0

  @observable customerAccountProjectStatus = undefined
  @observable customerAccountProjectCustOwner = undefined
  @observable activeCustomerDashboardProjectsLoader = false
  @observable activeCustomerDashboardProjects = []
  @observable activeCustomerDashboardProjectsTotal = 0

  @observable selectedProjectUser = undefined
  @observable projectsByUserTotal = 0
  @observable projectsByUsers = []
  @observable projectsByUserLoader = false
  @observable projectsCountByCustomerAssignedLoader = false
  @observable projectsCountByCustomersAssigned = []
  @observable projectsCountByCustomerLoader = false
  @observable projectsCountByCustomerTotal = 0
  @observable projectsCountByCustomers = []

  @observable customerShortDetails = {}

  @observable setCheckeFileList = []
  @observable isCheckAll = false
  @observable isIndeterminate = false

  @observable importCustomerWithUsers = []
  @observable importCustomerWithUsersLoader = false
  @observable importCustomerWithUsersFailures = []

  @action.bound
  setCustomerActionItemsSearchText = (value = undefined) => {
    this.customerActionItemsSearchText = value
  }

  @action.bound
  setCustomerActionItemsPageNo = (page = DEFAULT_PAGE_START) => {
    this.customerActionItemsPageNo = page
  }

  @action.bound
  setCustomerAttachmentsFilter = (value = {}) => {
    this.customerAttachmentsFilters = value
  }

  @computed
  get getTotalUsersInAddCustomers() {
    return this?.addCustomerData?.users?.length || 0
  }

  @action.bound
  setDownloadFile = async (list = [], totalFiles) => {
    this.setCheckeFileList = list
    this.isIndeterminate = !!list?.length && list?.length < totalFiles
    this.isCheckAll = list?.length === totalFiles
  }

  @action.bound
  downloadBulkFiles = async (list = {}, fileName) => {
    try {
      let options = {}
      options['ids'] = list
      options['zipFileName'] = fileName
      let response = await this.post(
        API_ENDPOINTS.EXPORT_MULTIPLE_FILES_TO_ZIP,
        options
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    if (value === 'status') {
      value = 'isActive'
    } else if (value === 'actionitems') {
      value = 'title'
    }
    this.orderingBy = value
  }

  @action.bound
  setFilters = (filters = {}) => {
    this.cfAllFilters = filters
  }

  @action.bound
  setSelectedDateChoice = (value = undefined) => {
    this.cfSelectedDateChoice = value
  }

  @action.bound
  setCompanySearchText = (value = '') => {
    this.companySearchText = value
  }

  @action.bound
  setCustomersPage = (value = DEFAULT_PAGE_START) => {
    this.customersPageNo = value
  }

  @action.bound
  setAttachmentsPage = (value = DEFAULT_PAGE_START) => {
    this.scAttachmentsPageNo = value
  }

  @action.bound
  setAttachmentsSearchText = (searchText = '') => {
    this.scAttachmentsSearchText = searchText
  }

  @action.bound
  resetEditData = () => {
    this.editCustomerData = observable({
      customer: observable({}),
      users: observable([]),
    })
  }

  @action.bound
  resetAddCustomerForm = () => {
    this.addCustomerCurrentTab = 1
    this.addCustomerData = observable({
      customer: {},
      users: observable([]),
    })
    this.addCustomerModalLoader = false
  }

  getFilterObjectsForCustomers = () => {
    let options = {}
    let keys = Object.keys(this.cfAllFilters || {})
    for (let filter of keys) {
      if (this.cfAllFilters[filter] !== undefined) {
        options[filter] = this.cfAllFilters[filter]
      }
    }
    if (this.cfSelectedDateChoice) {
      let dateFilter = getUtcUnixDate(this.cfSelectedDateChoice, {
        start: options['startDate'],
        end: options['endDate'],
      })
      options['startDate'] = dateFilter.start
      options['endDate'] = dateFilter.end
    } else {
      delete options['startDate']
      delete options['endDate']
    }

    delete options['choice']

    if (this.ordering) {
      options['ordering'] = this.ordering
      options['orderBy'] = this.orderingBy
    }

    return options
  }

  @action.bound
  getAllCustomers = async (signal) => {
    try {
      this.customersLoader = true
      let options = this.getFilterObjectsForCustomers()

      this.companySearchText && (options['search'] = this.companySearchText)
      this.customersPageNo &&
        (options['pageNo'] = Math.max(this.customersPageNo - 1, 0))
      let response = await this.post(
        API_ENDPOINTS.CUSTOMERS_LIST,
        options,
        signal
      )

      if (response.status) {
        this.customers = response.data.rows || []
        this.totalCustomers = response.data.count || 0
        return true
      } else {
        this.customers = []
        return false
      }
    } catch (err) {
      console.log(err, 137)
      this.customers = []
      return false
    } finally {
      this.customersLoader = false
    }
  }

  @action.bound
  getAllCustomersExportData = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFilterObjectsForCustomers()
      this.companySearchText && (options['search'] = this.companySearchText)
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_DATA, options)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  postCustomerDetails = async (details = {}) => {
    try {
      this.addCustomerModalLoader = true
      const {
        companyname,
        email,
        city,
        bio,
        phone,
        clogoo,
        docs,
        phoneExtension,
      } = details
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_CUSTOMER,
        generateFormData({
          name: companyname,
          email,
          city,
          bio: bio || '',
          phone,
          logo: clogoo,
          attachment: docs,
          phoneExtension: phoneExtension,
        })
      )
      if (response.status) {
        this.addCustomerData.customer = observable(response.data)
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.addCustomerModalLoader = false
    }
  }

  @action.bound
  setOrderingUser = (value = undefined) => {
    this.orderingUser = value
  }

  @action.bound
  setOrderingUserBy = (value = undefined) => {
    if (value === 'actionitems') {
      value = 'title'
    }
    this.orderingUserBy = value
  }

  @action.bound
  setUsersFilters = (filters = {}) => {
    this.cufAllFilters = filters
  }

  @action.bound
  setCustomerUserSearchText = (value = '') => {
    this.CustomerUserSearchText = value
  }

  @action.bound
  setCustomersUsersPage = (value = DEFAULT_PAGE_START) => {
    this.customersUsersPageNo = value
  }

  getFilterObjectsForCustomersUsers = () => {
    let options = {}
    let keys = Object.keys(this.cufAllFilters || {})
    for (let filter of keys) {
      if (this.cufAllFilters[filter] !== undefined) {
        options[filter] = this.cufAllFilters[filter]
      }
    }

    if (this.orderingUser) {
      options['ordering'] = this.orderingUser
      options['orderBy'] = this.orderingUserBy
    }

    return options
  }

  @action.bound
  getAllCustomersUsers = async (signal) => {
    try {
      this.customersUsersLoader = true
      let options = this.getFilterObjectsForCustomersUsers()

      this.CustomerUserSearchText &&
        (options['search'] = this.CustomerUserSearchText)
      this.customersUsersPageNo &&
        (options['pageNo'] = Math.max(this.customersUsersPageNo - 1, 0))
      let response = await this.post(
        API_ENDPOINTS.CUSTOMERS_USERS_LIST,
        options,
        signal
      )

      if (response.status) {
        this.customersUsers = response.data.users || []
        this.totalCustomersUsers = response.data.total || 0
        return true
      } else {
        this.customersUsers = []
        return false
      }
    } catch (err) {
      console.log(err, 137)
      this.customersUsers = []
      return false
    } finally {
      this.customersUsersLoader = false
    }
  }

  @action.bound
  getAllCustomersUsersExportData = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFilterObjectsForCustomersUsers()
      this.CustomerUserSearchText &&
        (options['search'] = this.CustomerUserSearchText)
      options['exportFileType'] = exportFileType
      let response = await this.post(
        API_ENDPOINTS.CUSTOMERS_USERS_EXPORT,
        options
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addOrUpdateCustomerUsersLocally = (user = {}, index = -1) => {
    if (index < 0) {
      this.addCustomerData.users.push(user)
    } else {
      if (this.addCustomerData.users[index]) {
        this.addCustomerData.users[index] = user
      } else {
        this.addCustomerData.users.push(user)
      }
    }
  }

  @action.bound
  postUserDetails = async (id, users) => {
    const usersObject = (users.usersList || []).map((user) => {
      const {
        firstName,
        avatar = undefined,
        lastName,
        email,
        contactNumber,
        title,
        role,
        city,
        state,
        country,
        phoneExtension,
      } = user

      return {
        email: email ? email?.trim?.() : undefined,
        firstName,
        lastName,
        title,
        customerId: id,
        roleId: role,
        profileImage: avatar,
        city,
        state,
        country,
        contactNumber,
        phoneExtension: phoneExtension,
      }
    })
    try {
      this.addCustomerModalLoader = true
      let response = await this.post(API_ENDPOINTS.BULK_USER, {
        users: usersObject,
      })
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      console.log(err)
      return [false, undefined]
    } finally {
      this.addCustomerModalLoader = false
    }
  }

  @action.bound
  getCustomerById = async (id) => {
    try {
      let customerByIdResponse = await this.post(API_ENDPOINTS.CUSTOMER_BY_ID, {
        customerId: id,
      })
      if (customerByIdResponse.status) {
        const { data } = customerByIdResponse
        this.editCustomerData = observable({
          customer: observable(data),
          users: observable([]),
        })

        return true
      }
      return false
    } catch (err) {
      return false
    }
  }

  @action.bound
  setCustomerByIdDetailsLocally = (values = {}) => {
    for (let key of Object.keys(values)) {
      this.scDetails[key] = values[key]
    }
  }

  @action.bound
  setCustomerByIdUsersLocally = (data = {}) => {
    let employess = this?.scDetails?.employees || []
    if (Array.isArray(data)) {
      ;(data || []).forEach((employee) => {
        if (employee.id) {
          employess.push(employee)
        }
      })
    } else {
      if (data.id) {
        employess.push(data)
      }
    }
  }

  @action.bound
  setUsersByIdCustomerLocally = (data = {}) => {
    let employess = this.customersUsers || []
    if (Array.isArray(data)) {
      ;(data || []).forEach((employee) => {
        if (employee.id) {
          employess.push(employee)
        }
      })
    } else {
      if (data.id) {
        employess.push(data)
      }
    }
    this.totalCustomersUsers = this.totalCustomersUsers + data.length
  }

  @action.bound
  deleteCustomerByIdUsersLocally = (id) => {
    let employees = this?.scDetails?.employees
    if (id && employees) {
      this.scDetails.employees = (employees || []).filter(
        (employee) => employee.id !== id
      )
    }
  }

  deleteUsersByIdCustomerLocally = (id) => {
    let customersUsers = this?.customersUsers
    if (id && customersUsers) {
      this.customersUsers = (customersUsers || []).filter(
        (customersUser) => customersUser.id !== id
      )
    }
    this.totalCustomersUsers--
  }

  @action.bound
  updateCustomerByIdUsersLocally = (values = {}) => {
    const id = values.id
    if (!id || !this?.scDetails?.employees) return

    this.scDetails.employees = (this.scDetails.employees || []).map(
      (employee) => {
        if (employee.id == id) {
          return { ...employee, ...values }
        } else {
          return employee
        }
      }
    )
  }

  @action.bound
  updateUsersByIdCustomerLocally = (values = {}) => {
    const id = values.id
    if (!id || !this?.customersUsers) return

    this.customersUsers = (this.customersUsers || []).map((employee) => {
      if (employee.id == id) {
        return { ...employee, ...values }
      } else {
        return employee
      }
    })
  }

  @action.bound
  getAttachmentsFilter = () => {
    let temp = {}

    let keys = Object.keys(this.customerAttachmentsFilters || {})
    for (let filter of keys) {
      if (this.customerAttachmentsFilters[filter] !== undefined) {
        temp[filter] = this.customerAttachmentsFilters[filter]
      }
    }

    this.scAttachmentsSearchText &&
      (temp['search'] = this.scAttachmentsSearchText)

    return temp
  }

  @action.bound
  getAttachmentdByCustomerId = async (id) => {
    try {
      this.scAttachmentsLoader = true
      let filteredObject = this.getAttachmentsFilter() || {}
      let customerAttachmentsResponse = await this.get(
        API_ENDPOINTS.GET_CUSTOMER_ATTTACHMENTS,
        {
          customerId: id,
          pageNo: Math.max(this.scAttachmentsPageNo - 1, 0),
          ...filteredObject,
        }
      )
      const { data, status } = customerAttachmentsResponse
      if (status) {
        const { count, rows = [] } = data
        this.scAttachments = rows
        this.scAttachmentsTotal = count
        return true
      } else {
        this.scAttachments = []
        this.scAttachmentsTotal = 0
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.scAttachmentsLoader = false
    }
  }

  @action.bound
  deleteAttachmentByCustomerId = async (data = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ATTACHMENTS, data)
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  overviewDetailsForCustomerById = async (id) => {
    try {
      this.scDetailsLoader = true
      let customerDetailsResponse = await this.post(
        API_ENDPOINTS.CUSTOMER_BY_ID,
        {
          customerId: id,
        }
      )
      if (customerDetailsResponse.status) {
        this.scDetails = customerDetailsResponse?.data || {}
        return true
      } else {
        return false
      }
    } catch (err) {
      console.log(err)
      return false
    } finally {
      this.scDetailsLoader = false
    }
  }

  @action.bound
  setCustomerStatus = async (customerId, values) => {
    try {
      let response = await this.post(API_ENDPOINTS.CUSTOMER_STATUS, {
        customerId,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteCustomer = async (id) => {
    try {
      this.deleteCustomerLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_CUSTOMER, {
        customerId: id,
      })
      if (response.status) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.deleteCustomerLoader = false
    }
  }

  @action.bound
  updateCustomer = async (id, values) => {
    try {
      const { bio, phone, email, city, companyname, clogoo } = values
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_CUSTOMER,
        generateFormData({
          id,
          name: companyname,
          bio: bio || '',
          email: email ? email?.trim?.() : undefined,
          phone: phone || '',
          city,
          logo: clogoo,
        })
      )

      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateCustomerLogo = async (values) => {
    try {
      this.updateCustomerLogoLoader = true
      const { id, clogo, deletelogo } = values
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_CUSTOMER,
        generateFormData({
          id,
          logo: clogo,
          deletelogo: deletelogo,
        })
      )
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.updateCustomerLogoLoader = false
    }
  }

  @action.bound
  getAllPosibleStatues = async () => {
    try {
      let response = await Promise.resolve({
        status: true,
        data: [
          {
            id: '1',
            name: 'Active',
            value: true,
          },
          {
            id: '2',
            name: 'Inactive',
            value: false,
          },
        ],
      })
      if (response.status) {
        this.allPosibileStatus = response.data
        return true
      } else {
        this.allPosibileStatus = []
        return false
      }
    } catch (err) {
      this.allPosibileStatus = []
      return false
    }
  }

  @action.bound
  getAllRoles = async (networkOnly = true) => {
    if (!networkOnly) {
      if (this.allRoles?.length) {
        return true
      }
    }
    try {
      let response = await this.get(API_ENDPOINTS.ALL_ROLES)
      if (response.status) {
        this.allRoles = response.data
        return true
      } else {
        this.allRoles = []
        return false
      }
    } catch (err) {
      this.allRoles = []
      return false
    }
  }

  @action.bound
  getAllCustomersForDropdown = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.CUSTOMER_DROPDOWN)
      if (response.status) {
        this.allCustomers = response.data
        return true
      }
      this.allCustomers = []
      return false
    } catch (err) {
      this.allCustomers = []
      return false
    }
  }

  @action.bound
  getAllCustOwnerForDropdownByCustId = async (customerId = undefined) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDONW_CUSTOMER_OWNER,
        {
          customerId: customerId,
        }
      )
      if (response.status) {
        this.allOwnerCustomerUsers = response?.data?.users
        return [true, response?.data?.users]
      }
      return [false, undefined]
    } catch (err) {
      this.allOwnerCustomerUsers = []
      return [false, undefined]
    }
  }

  @action.bound
  uploadCustomerDocuments = async (values = {}) => {
    try {
      this.scAttachmentsUploadLoader = true
      let response = await this.postWithFormData(
        API_ENDPOINTS.POST_CUSTOMER_ATTACHMENTS,
        generateFormData(values)
      )

      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.scAttachmentsUploadLoader = false
    }
  }

  @action.bound
  getCustomerDashboardDocuments = async (customerId) => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_CUSTOMER_ATTTACHMENTS, {
        customerId,
        pageNo: Math.max(this.customerDashboardAttachmentsPageNo - 1, 0),
      })
      if (response.status) {
        const { count, rows = [] } = response.data
        this.customerDashboardAttachmentsTotal = count
        this.customerDashboardAttachments = rows
        return [true, undefined]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getCustomerDashboardActionItems = async (customerId, {}, signal) => {
    try {
      let date = getCurrentTimeMoment()
      let options = {}
      options['endDateMax'] = getStartDate(date)
      options['orderBy'] = 'endDate'
      options['ordering'] = 'ASC'
      options['pageLimit'] = TOP_RECORDS_LIMIT

      let response = await this.get(
        API_ENDPOINTS.CUSTOMER_DASHBOARD_ACTION_ITEMS,
        {
          customerId,
          ...options,
        },
        signal
      )
      if (response.status) {
        const { total, actionItems = [] } = response.data
        this.customerDashboardActionItemsTotal = Math.min(
          response?.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.customerDashboardActionItems = actionItems
        return [true, undefined]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getCustomerActionItemsFilter = () => {
    let temp = {}
    let date = getCurrentTimeMoment()
    temp['endDateMax'] = getStartDate(date)
    temp['orderBy'] = 'endDate'
    temp['ordering'] = 'ASC'
    temp['pageLimit'] = TOP_RECORDS_LIMIT
    this.customerActionItemsSearchText &&
      (temp['search'] = this.customerActionItemsSearchText)
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getCustomerActionItems = async (customerId) => {
    try {
      this.customerActionItemsLoader = true
      let filters = this.getCustomerActionItemsFilter() || {}
      let response = await this.get(
        API_ENDPOINTS.CUSTOMER_DASHBOARD_ACTION_ITEMS,
        {
          customerId,
          pageNo: Math.max(this.customerActionItemsPageNo - 1, 0),
          ...filters,
        }
      )
      if (response.status) {
        const { total, actionItems = [] } = response.data
        this.customerActionItemsTotal = total
        this.customerActionItems = actionItems
        return [true, undefined]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.customerActionItemsLoader = false
    }
  }
  @action.bound
  getPieGraphStats = async (customerId, {}, signal) => {
    try {
      this.customerGraphStatsLoader = true
      let response = await this.get(
        API_ENDPOINTS.CUSTOMER_PROJECT_STATS_COUNT,
        {
          customerId,
        },
        signal
      )
      if (response.status) {
        this.customerGraphStats = response.data?.projectStatusCount || []
        this.customerGraphProjectsTotal = response.data?.totalProjectCount || 0
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.customerGraphStatsLoader = false
    }
  }

  resetCustomerGraphStats = () => {
    this.customerGraphStats = []
    this.customerGraphProjectsTotal = 0
  }

  @action.bound
  setCustomerAccountProjectStatus = (value = undefined) => {
    this.customerAccountProjectStatus = value
  }

  @action.bound
  setCustomerAccountProjectCustOwner = (value = undefined) => {
    this.customerAccountProjectCustOwner = value
  }

  @action.bound
  getActiveCustomerDashboardProject = async (customerId = undefined) => {
    try {
      this.activeCustomerDashboardProjectsLoader = true
      let options = {}
      options['pageLimit'] = 0
      options['customerId'] = customerId
      options['orderBy'] = 'startDate'
      options['ordering'] = 'DESC'
      this.customerAccountProjectCustOwner &&
        (options['ownerCustomer'] = [this.customerAccountProjectCustOwner])

      this.customerAccountProjectStatus &&
        (options['projectStatusId'] = [this.customerAccountProjectStatus])

      let response = await this.post(
        API_ENDPOINTS.GET_ALL_CUST_PROJECTS,
        options
      )

      if (response.status) {
        this.activeCustomerDashboardProjects = response.data.projects || []
        this.activeCustomerDashboardProjectsTotal = response.data.total || 0
        return true
      } else {
        this.activeCustomerDashboardProjects = []
        return false
      }
    } catch (err) {
      console.log(err, 131)
      this.activeCustomerDashboardProjects = []
      return false
    } finally {
      this.activeCustomerDashboardProjectsLoader = false
    }
  }

  // Project by user
  @action.bound
  setSelectedProjectUsers = async (uid) => {
    this.selectedProjectUser = uid
  }

  @action.bound
  getProjectsByUser = async (customerId = undefined) => {
    try {
      this.projectsByUserLoader = true
      let options = {}
      options['customerId'] = customerId
      this.selectedProjectUser && (options['userId'] = this.selectedProjectUser)
      let response = await this.post(API_ENDPOINTS.PROJECTS_BY_CUSTOMER_USER, {
        pageLimit: TOP_RECORDS_LIMIT,
        ...options,
      })
      if (response.status) {
        this.projectsByUserTotal = Math.min(
          response.data?.userProjects?.length || 0,
          TOP_RECORDS_LIMIT
        )
        this.projectsByUsers = response.data?.userProjects || []
        return this.projectsByUsers
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectsByUserLoader = false
    }
  }

  @action.bound
  resetProjectsPerUsers = async () => {
    this.projectsByUserTotal = 0
    this.projectsByUsers = []
    this.projectsByUserLoader = false
  }

  @action.bound
  setOrderingProjectsByUser = (value = undefined) => {
    this.orderingProjectsByUser = value
  }

  @action.bound
  setOrderingByProjectsByUser = (value = undefined) => {
    this.orderingByProjectsByUser = value
  }

  @action.bound
  getProjectCountByUser = async (customerId = undefined, {}, signal) => {
    try {
      let options = {}
      options['orderBy'] = 'projectCount'
      options['ordering'] = 'DESC'
      options['customerId'] = customerId
      this.projectsCountByCustomerLoader = true
      let response = await this.post(
        API_ENDPOINTS.PROJECTS_BY_CUSTOMER_USER,
        {
          pageLimit: TOP_RECORDS_LIMIT,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.projectsCountByCustomerTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.projectsCountByCustomers = response.data?.userProjectCount || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectsCountByCustomerLoader = false
    }
  }

  @action.bound
  resetProjectsCountPerUsers = async () => {
    this.projectsCountByCustomerTotal = 0
    this.projectsCountByCustomers = []
    this.projectsCountByCustomerLoader = false
  }
  // End project by user

  @action.bound
  getShortDetailsOfCustomer = async (customerId) => {
    if (this.customerShortDetails?.id === Number(customerId)) {
      return [true, this.customerShortDetails]
    }
    try {
      let response = await this.get(API_ENDPOINTS.CUSTOMER_SHORT_DETAILS, {
        customerId,
      })
      if (response.status) {
        this.customerShortDetails = response.data || {}
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  importCustomerWithUsersFromFile = async (values) => {
    try {
      this.importCustomerWithUsersLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_CUSTOMERS_WITH_USERS_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importCustomerWithUsers = response.data || []
        this.importCustomerWithUsersFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importCustomerWithUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importCustomerWithUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importCustomerWithUsersLoader = false
    }
  }

  @action.bound
  importCustomerWithUsersReset = async () => {
    this.importCustomerWithUsers = []
    this.importCustomerWithUsersFailures = []
  }

  @action.bound
  resetFilterForm = () => {
    this.cfSelectedDateChoice = undefined
    this.cfAllFilters = {}
    this.cufAllFilters = {}
  }

  @action.bound
  resetCustomerAttachmentsFilter = () => {
    this.customerAttachmentsFilters = {}
  }

  @action.bound
  resetStore = () => {
    this.customers = []
    this.totalCustomers = 0
    this.customersLoader = false

    this.companySearchText = ''
    this.customersPageNo = DEFAULT_PAGE_START
    this.customersPageLimit = DEFAULT_PER_PAGE_RECORD

    this.addCustomerData = observable({
      customer: observable({}),
      users: observable([]),
    })
    this.deleteCustomerLoader = false
    this.addCustomerModalLoader = false

    this.editCustomerData = observable({
      customer: observable({}),
      users: observable([]),
    })

    this.allPosibileStatus = []

    this.customersUsers = []
    this.totalCustomersUsers = 0
    this.customersUsersLoader = false

    this.orderingUser = undefined
    this.orderingUserBy = undefined

    this.emailId = ''
    this.customerName = ''
    this.CustomerUserSearchText = ''
    this.customersUsersPageNo = DEFAULT_PAGE_START
    this.customersUsersPageLimit = DEFAULT_PER_PAGE_RECORD

    // specific customer data
    this.scDetails = {}
    this.scDetailsLoader = false

    this.scAttachmentsLoader = false
    this.scAttachmentsUploadLoader = false
    this.scAttachmentsTotal = 0
    this.scAttachments = []
    this.scAttachmentsPageNo = DEFAULT_PAGE_START
    this.scAttahmentsPageLimit = DEFAULT_PER_PAGE_RECORD
    this.scAttachmentsSearchText = ''

    this.cfSelectedDateChoice = undefined
    this.cfAllFilters = {}

    this.ordering = undefined
    this.orderingBy = undefined
    // this.sortingStatusOrder = undefined
    this.allRoles = []

    this.getCustomerByIdLoader = false

    this.allCustomers = []
    this.allOwnerCustomerUsers = []
    this.customerOwners = []
    this.mediaCentricOwners = []

    this.customerAttachmentsFilters = {}

    this.customerDashboardAttachments = []
    this.customerDashboardActionItems = []
    this.customerDashboardAttachmentsPageNo = DEFAULT_PAGE_START
    this.customerDashboardActionItemsPageNo = DEFAULT_PAGE_START
    this.customerDashboardAttachmentsTotal = 0
    this.customerDashboardActionItemsTotal = 0

    this.customerActionItems = []
    this.customerActionItemsTotal = 0
    this.customerActionItemsLoader = false
    this.customerActionItemsPageNo = DEFAULT_PAGE_START
    this.customerActionItemsSearchText = ''

    this.customerGraphStats = []
    this.customerGraphStatsLoader = false
    this.customerGraphProjectsTotal = 0

    this.customerAccountProjectStatus = undefined
    this.customerAccountProjectCustOwner = undefined
    this.activeCustomerDashboardProjectsLoader = false
    this.activeCustomerDashboardProjects = []
    this.activeCustomerDashboardProjectsTotal = 0

    this.selectedProjectUser = undefined
    this.projectsByUserTotal = 0
    this.projectsByUsers = []
    this.projectsByUserLoader = false
    this.projectsCountByCustomerAssignedLoader = false
    this.projectsCountByCustomersAssigned = []
    this.projectsCountByCustomerLoader = false
    this.projectsCountByCustomerTotal = 0
    this.projectsCountByCustomers = []

    this.customerShortDetails = {}

    this.setCheckeFileList = []
    this.isCheckAll = false
    this.isIndeterminate = false

    this.importCustomerWithUsers = []
    this.importCustomerWithUsersFailures = []
    this.importCustomerWithUsersLoader = false
  }
}
